import {createContext, useContext, useState, FC, ReactNode} from "react";

// type StepStatus = "done" | "active" | "inactive";

interface Step {
  label: string | ReactNode;
  status: string;
  value?: number;
}

interface FilArianeContextType {
  steps: Step[];
  statut: string;
  etape: string;
  panierAriane: any[];
  demandeAriane: any;
  commandeAriane: any;
  listePOTAriane: any;
  selectedPOTAriane: any;
  setSteps: (steps: Step[]) => void;
  setStatut: (statut: string) => void;
  setEtape: (statut: string) => void;
  setPanierAriane: (panierAriane: any) => void;
  setDemandeAriane: (demandeAriane: any) => void;
  setCommandeAriane: (commandeAriane: any) => void;
  setListePOTAriane: (listePOTAriane: any) => void;
  setSelectedPOTAriane: (selectedPOTAriane: any) => void;
  resetFilAriane: () => void;
}

const FilArianeContext = createContext<FilArianeContextType | null>(null);

// Hook personnalisé
export const useFilAriane = () => {
  const ctx = useContext(FilArianeContext);
  if (!ctx) throw new Error("useFilAriane doit être dans FilArianeProvider");
  return ctx;
};

// Provider
export const FilArianeProvider: FC<{ children: ReactNode }> = ({children}) => {
  const [steps, setSteps] = useState<Step[]>([]);
  const [statut, setStatut] = useState<string>("");
  const [etape, setEtape] = useState<string>("");
  const [panierAriane, setPanierAriane] = useState<any>(null);
  const [demandeAriane, setDemandeAriane] = useState<any>(null);
  const [commandeAriane, setCommandeAriane] = useState<any>(null);
  const [listePOTAriane, setListePOTAriane] = useState<any>(null);
  const [selectedPOTAriane, setSelectedPOTAriane] = useState<any>(null);

  const resetFilAriane = () => {
    setSteps([]);
    setStatut("");
    setEtape("");
    setPanierAriane(null);
    setDemandeAriane(null);
    setCommandeAriane(null);
    setListePOTAriane(null);
    setSelectedPOTAriane(null);
  };

  return (
    <FilArianeContext.Provider value={{
      steps,
      statut,
      etape,
      panierAriane,
      demandeAriane,
      commandeAriane,
      listePOTAriane,
      selectedPOTAriane,
      setSteps,
      setStatut,
      setEtape,
      setPanierAriane,
      setDemandeAriane,
      setCommandeAriane,
      setListePOTAriane,
      setSelectedPOTAriane,
      resetFilAriane
    }}>
      {children}
    </FilArianeContext.Provider>
  );
};